import React, { useState } from 'react';
import axios from 'axios';
import { Button, Input, Typography } from "@material-tailwind/react";
import { handleRequestOtp, handleResetPassword, handleVerifyOtp } from '../../services/ApiServices/AuthenticationService';
import { useNavigate } from 'react-router-dom';

function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [step, setStep] = useState(1);
  const [error, setError] = useState("");
  const [message, setMessage] = useState("");
  const [showBackToLogin, setShowBackToLogin] = useState(false); // State to toggle back to login button
  const navigate = useNavigate();

  const handleBackToLogin = () => {
    navigate('/login');
  };

  const requestOtp = async (e: any) => {
    e.preventDefault();
    const response = await handleRequestOtp(email);
    if (response.success) {
      setStep(2);
      setMessage(response.message);
      setError("");
    } else {
      setError(response.message);
      setMessage("");
    }
  };

  const verifyOtp = async (e: any) => {
    e.preventDefault();
    const response = await handleVerifyOtp(email, otp);
    if (response.success) {
      setStep(3);
      setMessage(response.message);
      setError("");
    } else {
      setError(response.message);
      setMessage("");
    }
  };

  const resetPassword = async (e: any) => {
    e.preventDefault();
    const response = await handleResetPassword(email, otp, newPassword);
    if (response.success) {
      setMessage("Password reset successfully. You can now log in.");
      setError("");
      setShowBackToLogin(true); // Show back to login button
    } else {
      setError(response.message);
      setMessage("");
    }
  };

  return (
    <div className="flex justify-center w-full my-5">
      <div className="items-center mt-5 mb-5">
        <Typography placeholder={""} variant="h4" color="blue-gray">
          Forgot Password
        </Typography>
        {step === 1 && (
          <form onSubmit={requestOtp} className="mt-8 mb-2 w-80 max-w-screen-lg sm:w-96">
            <Input
              crossOrigin=""
              size="md"
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Email"
              className=" !border-t-blue-gray-200 focus:!border-t-gray-900"
              labelProps={{
                className: "before:content-none after:content-none",
              }}
            />
            <Button placeholder={""} type="submit" className="mt-6" fullWidth>
              Request OTP
            </Button>
            {error && <div className="text-red-500">{error}</div>}
            {message && <div className="text-green-500">{message}</div>}
          </form>
        )}
        {step === 2 && (
          <form onSubmit={verifyOtp} className="mt-8 mb-2 w-80 max-w-screen-lg sm:w-96">
            <Input
              crossOrigin=""
              size="md"
              onChange={(e) => setOtp(e.target.value)}
              placeholder="OTP"
              className=" !border-t-blue-gray-200 focus:!border-t-gray-900"
              labelProps={{
                className: "before:content-none after:content-none",
              }}
            />
            <Button placeholder={""} type="submit" className="mt-6" fullWidth>
              Verify OTP
            </Button>
            {error && <div className="text-red-500">{error}</div>}
            {message && <div className="text-green-500">{message}</div>}
          </form>
        )}
        {step === 3 && (
          <form onSubmit={resetPassword} className="mt-8 mb-2 w-80 max-w-screen-lg sm:w-96">
            <Input
              crossOrigin=""
              size="md"
              onChange={(e) => setNewPassword(e.target.value)}
              placeholder="New Password"
              type="password"
              className=" !border-t-blue-gray-200 focus:!border-t-gray-900"
              labelProps={{
                className: "before:content-none after:content-none",
              }}
            />
            <Button placeholder={""} type="submit" className="mt-6" fullWidth>
              Reset Password
            </Button>
            {error && <div className="text-red-500">{error}</div>}
            {message && <div className="text-green-500">{message}</div>}
            {showBackToLogin && (
              <Button placeholder={""} onClick={handleBackToLogin} className="mt-4" color="blue">
                Back to Login
              </Button>
            )}
          </form>
        )}
      </div>
    </div>
  );
}

export default ForgotPassword;
